import {AuthSource} from 'enums';

export const SALESFORCE_INTEGRATION_SOURCES = [
    AuthSource.Salesforce, AuthSource.SalesforceWidget
];

export const DEVICE_INTEGRATION_SOURCES = [
    AuthSource.AndroidSDK, AuthSource.IosSDK
];

export const APPOINTMENT_INTEGRATIONS = [
    AuthSource.AppointmentsApplication, AuthSource.SalesforceWidget
];
